import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'

function Index() {
  const { user } = useAuth0()
  const navigate = useNavigate()
  const isAdmin = (user as { 'https://app.etainabl.com/isAdmin'?: boolean })?.[
    'https://app.etainabl.com/isAdmin'
  ]
  // SPA navigation only — tokens live in memory, so a window.location redirect
  // here reloads the app, drops the session, and loops back through login.
  useEffect(() => {
    navigate({ to: (isAdmin ? '/admin' : '/tickets') as never, replace: true })
  }, [isAdmin, navigate])
  return <div className="p-8">Redirecting…</div>
}

export const Route = createFileRoute('/')({ component: Index })
